import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserNoDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserNoDataQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly lastCheckCollectDate?: string | null } | null } | null };

export type GetCurrentUserErrorQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserErrorQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly isPaymentError: boolean } | null };


export const GetCurrentUserNoDataDocument = gql`
    query GetCurrentUserNoData {
  currentUser {
    currentCompany {
      lastCheckCollectDate
    }
  }
}
    `;

/**
 * __useGetCurrentUserNoDataQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserNoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserNoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserNoDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserNoDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserNoDataQueryPage, GetCurrentUserNoDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserNoDataQueryPage, GetCurrentUserNoDataQueryVariables>(GetCurrentUserNoDataDocument, options);
      }
export function useGetCurrentUserNoDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserNoDataQueryPage, GetCurrentUserNoDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserNoDataQueryPage, GetCurrentUserNoDataQueryVariables>(GetCurrentUserNoDataDocument, options);
        }
export function useGetCurrentUserNoDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserNoDataQueryPage, GetCurrentUserNoDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserNoDataQueryPage, GetCurrentUserNoDataQueryVariables>(GetCurrentUserNoDataDocument, options);
        }
export type GetCurrentUserNoDataQueryHookResult = ReturnType<typeof useGetCurrentUserNoDataQuery>;
export type GetCurrentUserNoDataLazyQueryHookResult = ReturnType<typeof useGetCurrentUserNoDataLazyQuery>;
export type GetCurrentUserNoDataSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserNoDataSuspenseQuery>;
export type GetCurrentUserNoDataQueryResult = Apollo.QueryResult<GetCurrentUserNoDataQueryPage, GetCurrentUserNoDataQueryVariables>;
export const GetCurrentUserErrorDocument = gql`
    query GetCurrentUserError {
  currentUser {
    isPaymentError: isFlagEnabled(name: PAYMENT_ERROR)
  }
}
    `;

/**
 * __useGetCurrentUserErrorQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserErrorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserErrorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserErrorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserErrorQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserErrorQueryPage, GetCurrentUserErrorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserErrorQueryPage, GetCurrentUserErrorQueryVariables>(GetCurrentUserErrorDocument, options);
      }
export function useGetCurrentUserErrorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserErrorQueryPage, GetCurrentUserErrorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserErrorQueryPage, GetCurrentUserErrorQueryVariables>(GetCurrentUserErrorDocument, options);
        }
export function useGetCurrentUserErrorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserErrorQueryPage, GetCurrentUserErrorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserErrorQueryPage, GetCurrentUserErrorQueryVariables>(GetCurrentUserErrorDocument, options);
        }
export type GetCurrentUserErrorQueryHookResult = ReturnType<typeof useGetCurrentUserErrorQuery>;
export type GetCurrentUserErrorLazyQueryHookResult = ReturnType<typeof useGetCurrentUserErrorLazyQuery>;
export type GetCurrentUserErrorSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserErrorSuspenseQuery>;
export type GetCurrentUserErrorQueryResult = Apollo.QueryResult<GetCurrentUserErrorQueryPage, GetCurrentUserErrorQueryVariables>;